import { render } from "./ModalNotificationInvalid.vue?vue&type=template&id=408438e8&scoped=true"
import script from "./ModalNotificationInvalid.vue?vue&type=script&lang=js"
export * from "./ModalNotificationInvalid.vue?vue&type=script&lang=js"

import "./ModalNotificationInvalid.vue?vue&type=style&index=0&id=408438e8&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\dish-frontend-web-site\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-408438e8"]])

export default __exports__